<template>
	<teleport v-if="feedbackTeleportAnchor && feedback" :to="teleportAnchor">
		<p>{{feedback}}</p>
	</teleport>
	<text-input v-model="newPassword" :disabled="loading" :error="!!feedback" :force-focus="forceFocus" :size="size" password placeholder="Nieuw wachtwoord" @blur="validatePassword" @input="registerChanges" @keydown.enter="focusPasswordRepeatInput"/>
	<div class="password-strength-container">
		<span :class="['password-strength-level', newPassword ? strengthClass : '']"></span>
		<span :class="['password-strength-level', strength > 1 ? strengthClass : '']"></span>
		<span :class="['password-strength-level', strength > 2 ? strengthClass : '']"></span>
		<span :class="['password-strength-level', strength > 3 ? strengthClass : '']"></span>
	</div>
	<text-input v-model="newPasswordRepeat" :disabled="loading" :error="!!feedback" :force-focus="focusRepeat" :size="size" class="password-confirm" password placeholder="Bevestig wachtwoord" @keydown.enter="nextAction" @blur="validatePassword" @input="registerChanges"/>
</template>
<script>
import {SizeOptions, TextInput} from "@datapas/vue-input";
import zxcvbn from "zxcvbn";

export default {
	name: "PasswordInput",
	props: {
		forceFocus: {
			type: Number,
			default: 0
		},
		feedbackTeleportAnchor: {
			type: String,
			default: null
		},
		size: {
			default: SizeOptions.L,
			validator: (value) => SizeOptions[value] !== undefined
		}
	},
	components: {
		TextInput
	},
	emits: [
		'close',
		'hasChanges',
		'nextAction',
		'validatedPassword',
	],
	setup() {
		return {
			SizeOptions
		};
	},
	data() {
		return {
			loading: false,
			newPassword: "",
			newPasswordRepeat: "",
			feedback: null,
			focusRepeat: 0,
		};
	},
	computed: {
		teleportAnchor() {
			return this.feedbackTeleportAnchor ? '#' + this.feedbackTeleportAnchor : null;
		},
		passwordValid() {
			return this.strength > 2 && (this.newPassword === this.newPasswordRepeat);
		},
		strength() {
			return zxcvbn(this.newPassword ?? '').score;
		},
		strengthClass() {
			if (this.strength > 2) {
				return 'strength-good';
			} else {
				return this.strength > 1 ? 'strength-neutral' : 'strength-bad';
			}
		}
	},
	methods: {
		nextAction() {
			this.$emit('nextAction');
		},
		focusPasswordRepeatInput() {
			this.focusRepeat++;
		},
		setFeedback() {
			this.feedback = null;
			if (this.newPassword && this.newPasswordRepeat) {
				this.feedback = this.newPassword !== this.newPasswordRepeat ? "De wachtwoorden komen niet overeen" : null;
			}
		},
		validatePassword() {
			this.setFeedback();
			if (this.passwordValid) {
				this.$emit('validatedPassword', this.newPassword);
			} else {
				this.$emit('validatedPassword', null);
			}
		},
		registerChanges() {
			this.$emit('hasChanges', !!(this.newPassword || this.newPasswordRepeat));
		}
	}
};
</script>
<style lang="scss" scoped>
@use "@datapas/scss-framework/src/vars";
@use "@datapas/scss-framework/src/form";
@use "../scss/auth.scss";

.password-strength-container {
	display: grid;
	gap: vars.$CONTENT-SPACING-LABEL;
	grid-template-columns: repeat(4, 1fr);
	margin: vars.$CONTENT-SPACING-GEGROEPEERD 0;

	& .password-strength-level {
		background-color: vars.$DISABLED-BACKGROUND-COLOR;
		height: 5px;

		&.strength-bad {
			background-color: vars.$ERROR-FOREGROUND-COLOR;
		}

		&.strength-neutral {
			background-color: vars.$WARNING-FOREGROUND-COLOR;
		}

		&.strength-good {
			background-color: vars.$SUCCESS-FOREGROUND-COLOR;
		}
	}
}

.form .password-confirm {
	margin: 0;
}
</style>